import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ReglementDto } from "../../../dto/GenApi.iNotPaie.Dto/ReglementDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { EventBus } from "../../Controls/EventBus";
import { SalarieReglementDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieReglementDto";
import { ParametresInstance } from "../../Controls/Parameters";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface modelReglementSalarie {
	route: string;
	errorMessage: string[];
	salarieCourant: SalarieReglementDto;
	isModified: boolean;
}

@Component
export default class ReglementSalarieComponent extends Vue {
	public currentId = 0;
	public dataReady = false;
	public isModified = false;
    public salarieCourant: SalarieReglementDto = { Id: 0, IdSociete: 0, Reglement: { Id: 0, SiDeduiteSolde: false, Numero: 99 } };
	public salarieCharges: modelReglementSalarie[] = [];
	public errorMessage: string[] = [];

	public canModifyModeReglement = false;

	public reloadData(id: number): void {
    	if (this.currentId > 0) {
   		    this.salarieCharges[this.currentId] = {
    		    isModified: this.isModified,
    		    salarieCourant: this.salarieCourant,
    		    errorMessage: this.errorMessage,
    		    route: this.$router.currentRoute.path
    	    };
		}

        if (this.salarieCourant.Reglement == undefined) {
			this.salarieCourant.Reglement = { Id: 0, SiDeduiteSolde: false, Numero: 99 };
		}

    	this.currentId = id;
    	this.fetchData();
	}

	public resetData(id: number): void {
    	if (this.salarieCharges[id] != undefined) {
    		this.salarieCharges[id].isModified = false;
    	}
    	if (this.currentId == id) {
    		this.fetchData();
    	}
	}

	public mounted(): void {
    	EventBus.$on(EventConstants.UTILISATEUR_CHANGED, this.fetchData);
	}

	public fetchData(): void {
    	ServicesFactoryInstance.HeaderService.getHeaderInfos(() => {
    		if (ParametresInstance.utilisateurCourant == undefined) {
   			return;
   		}

    		this.canModifyModeReglement = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST, RoleConstants.UtilisateurPST]);

    		if (this.currentId < 1) {
   			return;
   		}
    		this.dataReady = false;
    		if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
    			ServicesFactoryInstance.SalarieService.getSalarieReglements(this.currentId, data => {
   				    if (data.Id != this.currentId) {
   					    return;
                    }

					this.salarieCourant = data;

					if (this.salarieCourant.Reglement == undefined) {
						this.salarieCourant.Reglement = { Id: 0, SiDeduiteSolde: false, Numero: 99 };
					}

                    this.dataReady = true;

                }, () => this.dataReady = true);

    		} else {
    			this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
				this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;

                if (this.salarieCourant.Reglement == undefined) {
                    this.salarieCourant.Reglement = { Id: 0, SiDeduiteSolde: false, Numero: 99 };
                }

    			this.isModified = this.salarieCharges[this.currentId].isModified;
    			this.dataReady = true;
			}
    	});
	}

	public modify(): void {
    	this.isModified = true;
    	this.$emit("isModified", true);
        this.$forceUpdate();
	}

	public annuler(): void {
    	this.fetchData();
    	this.isModified = false;
    	this.$emit("isModified", false);
	}

	public enregistrer(): boolean {
    	this.dataReady = false;
    	ServicesFactoryInstance.SalarieService.updateSalarieReglement(this.salarieCourant, (data) => {
    		this.$emit("isModified", false);
    		this.isModified = false;
    		this.salarieCourant = data;
    		this.dataReady = true;
    		NotificationServiceInstance.SendSuccess("L'enregistrement des règlements s'est correctement déroulé !");
    	}, () => this.dataReady = true);

    	return false;
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/reglement/reglement.ts